import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    photoId: PropTypes.number.isRequired,
    isActive: PropTypes.bool.isRequired,
    deletePhotoSelected: PropTypes.func.isRequired,
  },
  getInitialState() {
    return {
      isShaking: false,
    };
  },
  componentDidMount() {
    var delay = Math.random() * 1000;
    setTimeout(
      function() {
        this.setState({
          isShaking: true,
        });
      }.bind(this),
      delay
    );
  },
  handlePhotoDeleteButton() {
    this.props.deletePhotoSelected(this.props.photoId);
  },
  // キーボード（Enter / スペース）でも押せるようにする
  handleKeyDown(e) {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      this.handlePhotoDeleteButton();
    }
  },
  render() {
    if (this.props.isActive) {
      return (
        <div
          className={
            "delete-photo-button" + (this.state.isShaking ? " shake" : "")
          }
          onClick={this.handlePhotoDeleteButton}
          onKeyDown={this.handleKeyDown}
          role="button"
          tabIndex={0}
          aria-label="この写真を削除"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12" /></svg>
        </div>
      );
    } else {
      return (
        <div
          className={
            "delete-photo-button" + (this.state.isShaking ? " shake" : "")
          }
        />
      );
    }
  },
});
